import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import LocationPrompt from "./LocationPrompt";
import { getCurrentLocation } from "../redux/userLocationSlice";

/**
 * DeliveryAreaBar: where this basket is going, and the one-tap way to say so,
 * for cart surfaces that have no CoverageBanner of their own (the cart hub).
 * With an area set, every CartSummary below it can show its fee.
 */
const DeliveryAreaBar = ({ className, style }) => {
  const dispatch = useDispatch();
  const { latitude, longitude, address, isLoading } = useSelector((state) => state.userLocation || {});
  const [choosing, setChoosing] = useState(false);
  const hasArea =
    latitude !== null && latitude !== undefined && longitude !== null && longitude !== undefined;

  return (
    <Bar className={className} style={style}>
      <PlaceOutlinedIcon fontSize="small" aria-hidden="true" />
      {hasArea ? (
        <>
          <Text>
            <Muted>Delivering to</Muted> <strong>{address || "your set location"}</strong>
          </Text>
          <Action type="button" onClick={() => setChoosing(true)}>Change</Action>
        </>
      ) : (
        <>
          <Text>
            {isLoading ? "Finding your location" : "Set your area to see delivery fees and arrival times"}
          </Text>
          <Actions>
            <Action type="button" onClick={() => dispatch(getCurrentLocation())} disabled={isLoading}>
              Use my location
            </Action>
            <Action type="button" onClick={() => setChoosing(true)}>Choose area</Action>
          </Actions>
        </>
      )}
      {choosing && <LocationPrompt open onClose={() => setChoosing(false)} />}
    </Bar>
  );
};

const Bar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
  padding: 12px 14px;
  margin: 0 0 14px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e1e6de;
  color: #15232a;
  font-size: 14px;
  line-height: 1.4;

  > svg {
    color: #24525f;
    flex-shrink: 0;
  }
`;

const Text = styled.span`
  flex: 1 1 200px;
  min-width: 0;
  overflow-wrap: anywhere;
`;

const Muted = styled.span`
  color: #55646a;
`;

const Actions = styled.span`
  display: inline-flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const Action = styled.button`
  min-height: 36px;
  padding: 0 14px;
  border: none;
  border-radius: 10px;
  background: #e3eef2;
  color: #15232a;
  font: inherit;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export default DeliveryAreaBar;
